import { SiteHeaderIconButton, SiteHeaderIconLink, SiteHeaderImageLink } from "@xapp/components";
import { UserProfile } from "auth/modules/state";
import React, { FC } from "react";

export interface UserMenuProps {
    readonly profile: Pick<UserProfile, "icon">;
    login(): void;
}

export const UserMenu: FC<UserMenuProps> = props => {
    const { profile } = props;
    const authorized = !!profile;
    if (!authorized) {
        return (
            <SiteHeaderIconButton icon="account_circle" onClick={props.login} />
        );
    }
    if (profile.icon) {
        return (
            <SiteHeaderImageLink href="/settings" src={profile.icon} />
        );
    }
    return (
        <SiteHeaderIconLink href="/settings" icon="account_circle" />
    );
};
